import React from 'react';
import '../../styles/facingTrouble.css';
import { FACING_TROUBLE_LIST, FACING_TROUBLE_TITLE } from '../../utils/RailsSEOConstants';
import { navigateTo } from '../../utils/commonUtils';
import PropTypes from 'prop-types';

const FacingTrouble = ({ customClass, facingTroubleList = FACING_TROUBLE_LIST }) => {
  return (
    <div className={`${customClass} facingTrouble`}>
      <h6>{FACING_TROUBLE_TITLE}</h6>
      <ul>
        {facingTroubleList &&
          facingTroubleList.map((item) => {
            return (
              <li key={item.title} onClick={() => navigateTo(item.navigationUrl)}>
                {item.title}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

FacingTrouble.propTypes = {
  customClass: PropTypes.string,
  facingTroubleList: PropTypes.array
};

export default FacingTrouble;
